import authentication from "@irati/auth";
import client from "@irati/utils/services/apollo";
import getSavedCardsQuery, { savedCardsKey } from "./queries/GetSavedCardsQuery";
import deleteSavedCardMutation, { deleteSavedCardKey } from "./mutations/DeleteSavedCardMutation";
var SavedCards = /** @class */ (function () {
    function SavedCards() {
    }
    SavedCards.prototype.list = function (savedCardProvider, _a) {
        if (savedCardProvider === void 0) { savedCardProvider = defaultSavedCardProvider(); }
        var _b = (_a === void 0 ? {} : _a).forceRefetch, forceRefetch = _b === void 0 ? true : _b;
        var fetchPolicy = forceRefetch ? "network-only" : "cache-first";
        var variables = {
            provider: savedCardProvider.provider
        };
        return client.query({ query: getSavedCardsQuery, variables: variables, fetchPolicy: fetchPolicy }).then(function (_a) {
            var data = _a.data;
            return data[savedCardsKey];
        });
    };
    SavedCards.prototype.delete = function (card, savedCardProvider) {
        if (savedCardProvider === void 0) { savedCardProvider = defaultSavedCardProvider(); }
        var variables = {
            provider: savedCardProvider.provider,
            cardReference: card.reference
        };
        return client.mutate({ mutation: deleteSavedCardMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data[deleteSavedCardKey];
        });
    };
    return SavedCards;
}());
var service = new SavedCards();
export var getSavedCards = service.list;
export var deleteSavedCard = service.delete;
export default service;
export function defaultSavedCardProvider() {
    return {
        provider: authentication.userPaymentProvider()
    };
}
